import { Box, Typography } from "@mui/material";

import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const PCM_DOCUMENT_TYPE_OPTIONS = [
  { value: "Administrative Guide", label: "Administrative Guide" },
  {
    value: "Assurance Activity Report",
    label: "Assurance Activity Report",
  },
  { value: "Other Documents", label: "Other Documents" },
];

// move this to a centralized types area
export interface PcmFileMetadata {
  file_id?: number;
  file?: File;
  fileType?: string;
  fileLabel?: string;
  fileName?: string;
  active?: boolean;
}

const PcmFileUploadSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {
    isMaintenance: false,
  },
  render: function Render({ form, isMaintenance }) {
    // TODO: look into if there is a centralized place we can pull these from

    return (
      <Box sx={{ mb: 4 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          FILE UPLOADS
        </Typography>
        <Box sx={{ border: 1, borderColor: "divider", p: 3, borderRadius: 1 }}>
          <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
            {isMaintenance
              ? "Attach updated Administrative Guidance (AGD) if applicable."
              : "Attach supporting documents that are not posted on the Common Criteria Portal to include the Administrative Guide (AGD), Assurance Activity Report (AAR) required for inclusion to the NIAP PCL"}
          </Typography>

          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            gap={3}
            sx={{ mb: 2 }}
          >
            <Box flex={1}>
              <form.AppField name="fileType">
                {(field) => (
                  <field.SelectField
                    options={PCM_DOCUMENT_TYPE_OPTIONS}
                    label="Document Type"
                    onChange={(val) => {
                      //@ts-ignore
                      form.setFieldValue("fileLabel", val);
                    }}
                  />
                )}
              </form.AppField>
            </Box>
            <Box flex={1}>
              <form.AppField name="fileLabel">
                {(field) => <field.TextInput label="File Label" />}
              </form.AppField>
            </Box>
          </Box>

          <form.AppField name="files">
            {(field) => (
              <field.FileUpload
                disabled={false}
                label="Choose File"
                annotateFile={(file: File) => {
                  const fileType = form.getFieldValue("fileType");
                  const fileLabel = form.getFieldValue("fileLabel");
                  const fileName = file.name;
                  const active = true;

                  return {
                    fileType,
                    fileLabel,
                    fileName,
                    active,
                  };
                }}
              />
            )}
          </form.AppField>

          <Box
            flex="1 1 100%"
            display="flex"
            gap={2}
            flexWrap="wrap"
            sx={{ mt: 3 }}
          >
            <form.AppField name="files">
              {(field) =>
                field.state.value
                  .filter((file: PcmFileMetadata) => file.active)
                  .map((file: PcmFileMetadata, index: number) => {
                    return (
                      <field.FileCard
                        // Cast to File - we provide title/fileName explicitly so file.name isn't needed
                        file={(file.file || file) as unknown as File}
                        title={file.fileLabel || file.fileType}
                        fileName={file.fileName}
                        index={index}
                        key={`${file.file_id || file.fileName}-${index}`}
                      />
                    );
                  })
              }
            </form.AppField>
          </Box>
        </Box>
      </Box>
    );
  },
});

export default PcmFileUploadSection;
